<template>
  <div class="upload-single component">
    <div class="top-tools">
      <input type="file" @change="makePreviewImage" accept="image/*" ref="file">
      <button @click="upload">upload</button>
      <button @click="cancelImage">cancel</button>
    </div>
    <div class="loading-status">
      <div class="loading" v-if="loading">loading</div>
      <div class="done" v-if="done">loaded, all done</div>
      <div class="error" v-if="error">Error: {{ error }}</div>
    </div>
    <div v-if="previewImageData" class="preview">
      <img :src="previewImageData" alt="image">
    </div>
  </div>
</template>

<script>
  import * as albumsApi from '../services/albums.service'
  export default {
    name: 'UploadSingle',

    props: {
      entityId: {
        type: Number
      },
      entityType: {
        type: String,
        validator: type => {
          return ['cover_index', 'cover_thumbnail'].includes(type)
        }
      },
      maxSize: {
        type: Number,
        default: 1024 * 1024 * 1 // 1MB
      },
      types: {
        type: Array,
        default: () => ['jpg', 'jpeg']
      }
    },

    data () {
      return {
        loading: false,
        done: false,
        error: false,
        previewImageData: ''
      }
    },

    methods: {
      makePreviewImage (event) {
        const file = event.target.files[0]

        if (this.isValidFile(file)) {
          let reader = new FileReader()
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.previewImageData" refers to the previewImageData of Vue component
            // Read image as base64 and set to imageData
            this.previewImageData = e.target.result
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(file)
        }
      },
      uploadCoverIndex (data) {
        this.loading = true
        this.done = false
        this.error = false

        albumsApi.uploadCoverIndexImage(this.entityId, data)
          .then(response => (this.done = true))
          .catch(error => {
            this.$snotify.error(error.message, 'Error')
            this.error = error.message
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      uploadCoverThumbnail (data) {
        this.loading = true
        this.done = false
        this.error = false

        albumsApi.uploadCoverThumbnailImage(this.entityId, data)
          .then(response => (this.done = true))
          .catch(error => {
            this.$snotify.error(error.message, 'Error')
            this.error = error.message
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      upload () {
        const selectedFile = this.$refs.file.files[0]

        if (this.previewImageData) {
          const data = new FormData()
          data.append(this.entityType, selectedFile)

          if (this.entityType === 'cover_index') {
            this.uploadCoverIndex(data)
          }
          if (this.entityType === 'cover_thumbnail') {
            this.uploadCoverThumbnail(data)
          }
        }
      },
      cancelImage () {
        this.previewImageData = ''
        this.resetAllStatuses()
      },
      resetAllStatuses () {
        this.loading = false
        this.done = false
        this.error = false
      },
      isValidFile (file) {
        if (!file) return

        let isValid = true
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        this.resetAllStatuses()
        this.cancelImage()

        if (file.size > this.maxSize) {
          this.error = `Max size per file = ${this.maxSize / 1024 / 1024} MB.`
          return (isValid = false)
        }
        if (!this.types.includes(extension)) {
          this.error = `Not allowed file type.`
          return (isValid = false)
        }

        return isValid
      }
    }
  }
</script>

<style lang="scss" scoped>
  .upload-single {
    .top-tools {
      padding: 15px 0;
      text-align: center;
    }
    .loading-status {
      text-align: center;
      padding-bottom: 15px;
      top: 40%;
      left: 45%;
      font-size: 16px;
    }
    .preview {
      width: 100%;
      text-align: center;
      img {
        display: inline-block;
        width: 300px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/UploadSingle.vue